import { ReactElement } from 'react';
import { history } from 'umi';
import { Row, Col, Statistic, Tooltip } from 'antd';
import { Typography, Button } from 'iglooform';
import { useIntl } from 'react-intl';
import './cash-out-card.less';
import { AlertFilled } from 'iglooicon';

interface IEarningCardOutCard {
  cashOutLoading: boolean;
  balance: any;
  checkBankAccount: any;
  currentLang: string;
  currency: string;
  isPc: boolean;
}

const CashOutCard = ({
  cashOutLoading,
  balance,
  checkBankAccount,
  currentLang,
  currency,
  isPc,
}: IEarningCardOutCard): ReactElement => {
  const { formatMessage } = useIntl();

  return (
    <Row className="cash-out-form">
      <Col
        span={24}
        style={{ width: '100%', marginTop: '0' }}
        className="cash-out-card"
      >
        <Statistic
          valueStyle={{ color: '#5858FF' }}
          className="card-statistic"
          title={
            <Typography
              level="body1"
              style={{ display: 'block', color: '#999', marginBottom: '8px' }}
            >
              {formatMessage({ id: 'Current Total Earnings' })}
            </Typography>
          }
          value={balance?.available}
          prefix={formatMessage({ id: 'VND' })}
          groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
          decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
        />
        <section className="net-cash">
          <Typography
            level="body1"
            style={{
              display: 'block',
              float: 'left',
              marginRight: '4px',
              color: '#999',
            }}
          >
            {formatMessage({ id: 'Net Cash Amount: ' })}
          </Typography>
          <Statistic
            className="net-cash-ava"
            value={balance?.net_amount}
            prefix={formatMessage({ id: 'VND' })}
            valueStyle={{ color: '#999' }}
            groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
            decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
          />
          <Tooltip
            placement={'bottom'}
            title={formatMessage({
              id: 'This is the total amount that can be cashed out after goverment mandated income taxation of 10% on your total earnings.',
            })}
          >
            <AlertFilled style={{ fontSize: '24px', color: '#999' }} />
          </Tooltip>
        </section>
        <section className="btn-container">
          <Button
            type="primary"
            loading={cashOutLoading}
            onClick={checkBankAccount}
            className="button"
          >
            <Typography level="body1">
              {formatMessage({ id: 'Cash out' })}
            </Typography>
          </Button>
          <Button
            type="link"
            onClick={() =>
              history.push('/earnings/cash-history?currency=' + currency)
            }
            style={{ marginTop: '6px' }}
          >
            <Typography level="body2">
              {formatMessage({ id: 'Cash out History' })}
            </Typography>
          </Button>
        </section>
      </Col>
    </Row>
  );
};

export default CashOutCard;
